<template>
    <!-- 阅读卡片 -->
    <div :class="['card-container', showFront ? '' : 'flipped']" @click="handleRotate">
        <div
            :class="['card', 'reading-card', addClass]"
        >
            <div class="reading-header">
                <p class="title">今日阅读</p>
                <img
                    class="favorite-icon"
                    src="https://i.gsxcdn.com/2714850963_6fofmyar.png"
                >
            </div>
            <div class="reading-body">
                <p class="reading-count">
                    <span class="count">{{readNum}}</span>
                </p>
                <p class="speaking-count">
                    开口表达 <span class="count">{{openExpressNum}}</span> 次
                </p>
            </div>
        </div>
        <div
            :class="['card', 'reading-summary-card', addBackClass]"
        >
            <div class="card-header">
                <img
                    :src="courseCoverUrl"
                    class="summary-image"
                >
                <div class="summary-info">
                    <p class="story-title">{{monthThemeTxt}}</p>
                    <p class="reading-month">本月累计阅读</p>
                    <p class="reading-countnum" v-html="readTotalStr">
                    </p>
                    <div class="progress-box">
                        <div class="progress-bar">
                            <div class="progress" :style="{ width: `${readProgress}%` }"></div>
                        </div>
                        <p class="progress-percentage">{{readProgress}}%</p>
                    </div>
                </div>
                <img
                    src="https://i.gsxcdn.com/2714850963_6fofmyar.png"
                    alt="favorite"
                    class="favorite-icon"
                >
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    mounted() {
        setInterval(() => {
            this.handleRotate();
        }, 5000);
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const formatNumber = num => {
            // 如果数字小于10000，直接返回数值加上"字"或者"次"
            if (num < 10000) {
                // 或者 "次" 根据需要调整
                return `<span style='font-size: .56rem;margin-right: .11rem;'>${num}</span>字`;
            }
            // 如果数字大于或等于10000，保留一位小数，返回格式化的万数
            return `<span style='font-size: .56rem;margin-right: .11rem;'>${(num / 10000).toFixed(1)}</span>万字`;
        };
        const {
            // 今日阅读字数
            readNum,
            // 开口表达次数
            openExpressNum,
            // 月主题文字
            monthThemeTxt,
            // 课程封面
            courseCoverUrl,
            // 本月累计阅读字数
            readTotalNum,
            // 进度条
            readProgress
        } = this.pageData.readCardInfo;
        return {
            // 今日阅读字数
            readNum,
            // 开口表达次数
            openExpressNum,
            // 月主题文字
            monthThemeTxt,
            // 课程封面
            courseCoverUrl,
            // 本月累计阅读字数
            readTotalStr: formatNumber(readTotalNum),
            // 进度条
            readProgress
        };
    },
    computed: {

    },
    watch: {

    }
})
export default class Speech extends Vue {
    showFront = true;
    addBackClass = 'reading-summary-card-to-back';
    addClass = 'reading-card-to-front';
    // 翻转
    handleRotate() {
        this.showFront = !this.showFront;
        setTimeout(() => {
            this.addClass = this.showFront ? 'reading-card-to-front' : 'reading-card-to-back';
            this.addBackClass = this.showFront ? 'reading-summary-card-to-back' : 'reading-summary-card-to-front';
        }, 300);
    }
}
</script>

<style lang="scss" scoped>
/* 父容器 */
.card-container {
    perspective: 1000px;
    position: relative;
    width: 8.51rem;
    height: 3.79rem;
    margin-bottom: .35rem;
}

.reading-card-to-front {
    transition: transform 150ms ease-in-out;
}
.reading-summary-card-to-front {
    transition: transform 150ms ease-in-out;
}

.reading-card-to-back {
    transition: transform 150ms ease-in-out 150ms;
}
.reading-summary-card-to-back {
    transition: transform 150ms ease-in-out 150ms;
}

.reading-card {
    transform: scaleX(1);
    z-index: 2;
}

.reading-summary-card {
    transform: scaleX(0);
    z-index: 1;
}

/* 翻转后的效果 */
.flipped .reading-card {
    transform: scaleX(0);
}

.flipped .reading-summary-card {
    transform: scaleX(1);
}

/* 卡片 */
.card {
    position: absolute;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
}

.reading-card {
    border-radius: .4rem;
    width: 8.51rem;
    height: 3.79rem;
    background: url(https://i.gsxcdn.com/2714857556_deq2jlb3.png) 0 0 no-repeat;
    background-size: cover;
    margin-top: .16rem;
    // margin-bottom: .35rem;

    .reading-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            margin-top: .64rem;
            margin-left: .64rem;
            font-size: .4rem;
            color: #A52002;
            font-weight: 600;
        }

        .favorite-icon {
            margin-right: .27rem;
            width: .72rem;
            height: .72rem;
        }
    }

    .reading-body {
        position: relative;
        margin-top: .13rem;
        margin-left: .64rem;

        .reading-count {
            font-size: .45rem;
            color: #FA421D;
            font-weight: bold;

            .count {
                font-size: 1.01rem; // 对应设计图中大的数字
            }
        }

        .speaking-count {
            font-size: .32rem;
            color: #0B0B0B;
            margin-top: .64rem;
            margin-left: .35rem;

            .count {
                font-size: .4rem; // 突出数字
                color: #FA421D;
                font-weight: 600;
            }
        }
    }
}

.reading-summary-card {
    width: 8.51rem;
    height: 3.79rem;
    background: url(https://i.gsxcdn.com/2714908697_fcqyk66l.png) 0 0 no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-bottom: .35rem;
    margin-top: .16rem;

    .card-header {
        width: 90%;
        display: flex;
        align-items: center;

        .summary-image {
            width: 2.67rem;
            height: 2.67rem;
            border-radius: .35rem;
        }

        .summary-info {
            margin-left: .29rem;
            text-align: left;

            .story-title {
                font-weight: 600;
                font-size: .48rem;
                color: #A52002;
                line-height: .56rem;
                max-width: 4.08rem; // 控制文字溢出
            }

            .reading-month {
                margin-top: .29rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: .32rem;
                color: #0B0B0B;
            }

            .reading-countnum {
                font-size: .32rem;
                color: #A52002;
                margin: .05rem 0;
                font-weight: 600;
            }

            .progress-box {
                display: flex;
                align-items: center;

                .progress-bar {
                    width: 3.57rem;
                    height: .21rem;
                    background-color: rgba(171, 81, 30, .21);
                    border-radius: .11rem;
                    overflow: hidden;
                    margin-top: .05rem;

                    .progress {
                        height: 100%;
                        background: #FFFFFF;
                        border-radius: .11rem;
                    }
                }

                .progress-percentage {
                    text-align: right;
                    font-size: .34rem;
                    color: #A52002;
                    margin-left: .21rem;
                    font-weight: 600;
                }
            }
        }

        .favorite-icon {
            width: .72rem;
            height: .72rem;
            position: relative;
            right: .2rem;
            top: -1.4rem;
        }
    }
}
</style>
